import React from 'react';

export default class  Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="innovativeimg">
                                                    <img alt=""
                                                         src={require('@images/How to develop rapport.png')}/>
                                                </div>

                                                <div className="ilead-contentarea">

                                                    <div className="circle_title"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>isn't it interesting?</div>
                                                    <p>When you meet someone for the first time what do you think?</p>
                                                    <div className="border_subtitle">Do you jump to conclusions about
                                                        people?
                                                    </div>
                                                    <p>Yes? No? Sometimes? We’ll bet most would answer: ‘No, of course
                                                        not.’ However, we’re all constantly bombarded with information
                                                        with often little time to make anything other than snap
                                                        judgements. Some researchers even suggest we’re ‘hard-wired’
                                                        that way because we needed to think fairly rapidly back when we
                                                        were hunting and gathering, fighting or fleeing. The challenge
                                                        in a work environment is to identify when quick decisions are
                                                        appropriate and, more important, when they aren’t.</p>


                                                    <div className="lightgreencontentbg keyquestionpad">
                                                        <div className="border_subtitle">Good looking, looking good
                                                        </div>
                                                        <p>In one of the most famous social experiments of recent years,
                                                            Alex Todorov and colleagues ran a study of how snap
                                                            judgements can affect the ways we behave towards people.<a
                                                                className="superscripttext"
                                                                href="further_info.php?course=300"><sup>1</sup></a> The
                                                            researchers asked participants to look at a number of faces
                                                            and rate them each for trustworthiness. They found people
                                                            did this confidently, within milliseconds of looking at a
                                                            face. When the participants were given more time to look (a
                                                            few seconds) their judgements still didn’t alter. The only
                                                            thing that changed was people’s confidence in their
                                                            judgement.</p>
                                                        <p>What really amazed the researchers was the degree to which
                                                            participants were willing to make important judgements
                                                            (trusting others or not) based only on the way people
                                                            looked. Subsequent studies have found that we make all sorts
                                                            of generalised judgements about people, based on nothing
                                                            more than their looks, and that if we see one outstanding
                                                            positive feature (such as good looks) in a person, we
                                                            readily make additional, positive assumptions that they’re
                                                            clever, witty and reasonable. This simple, yet very powerful
                                                            and consistent finding, is known as the halo effect.<a
                                                                className="superscripttext"
                                                                href="further_info.php?course=300"><sup>2</sup></a></p>
                                                    </div>

                                                    <div className="right-btn"><div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div></div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}